import Link from 'next/link';
import { type MouseEvent } from 'react';
import Badge from '@discover-ui/badge';
import { type RestaurantDetails } from '@discover-data/stores/restaurant/gql/getters/restaurantDetails';
import RestaurantRating from '@discover-components/restaurant/rating';
import Root, { type RootProps } from './root';

export type RestaurantCardTitleRowProps = Pick<
  RestaurantDetails,
  'menuTitle' | 'slug' | 'approvedReviewsCount' | 'rating'
> &
  Omit<RootProps, 'children'> & {
    reviewsHref: string;
    badge?: string | null;
    hideRating?: boolean;
    onRestaurantClick?: () => void;
    onReviewsClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  };

export default function RestaurantCardTitleRow({
  slug,
  reviewsHref,
  menuTitle,
  className,
  badge,
  rating,
  approvedReviewsCount,
  hideRating = false,
  onRestaurantClick,
  onReviewsClick,
  ...props
}: RestaurantCardTitleRowProps) {
  return (
    <Root className={className} {...props}>
      <h3 className="mb-0 flex-1 text-[16px] font-semibold leading-[22px] tracking-tight md:text-[24px] md:leading-[32px]">
        <Link href={slug || '#'} onClick={onRestaurantClick}>
          {menuTitle} &rsaquo;
        </Link>
      </h3>
      {badge && <Badge kind="accent">{badge}</Badge>}
      {!hideRating && !!rating && !!approvedReviewsCount && (
        <Link
          href={reviewsHref}
          onClick={onReviewsClick ?? onRestaurantClick}
          className="hidden no-underline hover:underline md:inline">
          <RestaurantRating
            className="leading-tight"
            rating={rating}
            count={approvedReviewsCount}
          />
        </Link>
      )}
    </Root>
  );
}
